// @ts-nocheck
const CustomerBilling = () => {
    return (
        <div>CustomerBilling</div>
    )
}

export default CustomerBilling